import FormInputDate from './component.jsx'
export default FormInputDate
